import { Route } from "react-router-dom";
import { lazyWithRetry as lazy } from "@/lib/lazyWithRetry";
import ProtectedRoute from "@/components/ProtectedRoute";
import FeatureRoute from "@/components/FeatureRoute";

const StockOverview = lazy(() => import("@/pages/stock/StockOverview"));
const ArticlesPage = lazy(() => import("@/pages/stock/ArticlesPage"));
const ArticlesJournalPage = lazy(() => import("@/pages/stock/ArticlesJournalPage"));
const MouvementsPage = lazy(() => import("@/pages/stock/MouvementsPage"));
const AjustementsPage = lazy(() => import("@/pages/stock/AjustementsPage"));
const AssignationsPage = lazy(() => import("@/pages/stock/AssignationsPage"));
const TransfertsPage = lazy(() => import("@/pages/stock/TransfertsPage"));
const ConsommationTheoriquePage = lazy(() => import("@/pages/stock/ConsommationTheoriquePage"));
const ConsommationDetailPage = lazy(() => import("@/pages/stock/ConsommationDetailPage"));
const StockEcartsPage = lazy(() => import("@/pages/stock/StockEcartsPage"));
const DecrementsJournalPage = lazy(() => import("@/pages/stock/DecrementsJournalPage"));
const CigaresListPage = lazy(() => import("@/pages/stock/cigares/CigaresListPage"));
const CigaresFormPage = lazy(() => import("@/pages/stock/cigares/CigaresFormPage"));
const CigaresEntreesPage = lazy(() => import("@/pages/stock/cigares/CigaresEntreesPage"));
const CigaresVentesPage = lazy(() => import("@/pages/stock/cigares/CigaresVentesPage"));
const PatrimoineListPage = lazy(() => import("@/pages/stock/patrimoine/PatrimoineListPage"));
const PatrimoineDetailPage = lazy(() => import("@/pages/stock/patrimoine/PatrimoineDetailPage"));
const InventairePage = lazy(() => import("@/pages/stock/inventaire/InventairePage"));
const InventaireHistoriquePage = lazy(() => import("@/pages/stock/inventaire/InventaireHistoriquePage"));
const InventaireDetailPage = lazy(() => import("@/pages/stock/inventaire/InventaireDetailPage"));

export function stockRoutes() {
  return (
    <>
      <Route
        path="/stock/vue-ensemble"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <StockOverview />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/articles"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "admin"]}>
            <ArticlesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/articles/journal"
        element={
          <ProtectedRoute allowedRoles={["controleur", "gerante", "pdg", "admin"]}>
            <ArticlesJournalPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/assignations"
        element={
          <ProtectedRoute allowedRoles={["barman", "cuisinier", "gestionnaire", "controleur", "gerante", "admin"]}>
            <AssignationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/transferts"
        element={
          <ProtectedRoute allowedRoles={["barman", "cuisinier", "gestionnaire", "controleur", "gerante", "admin"]}>
            <TransfertsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/mouvements"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "admin"]}>
            <MouvementsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/ajustements"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "admin"]}>
            <AjustementsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/conso"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="stock.niveau2"><ConsommationTheoriquePage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/conso/:articleId"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="stock.niveau2"><ConsommationDetailPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/ecarts"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="stock.niveau2"><StockEcartsPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/decrements"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="stock.niveau2"><DecrementsJournalPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/cigares"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "caissiere", "admin"]}>
            <FeatureRoute flag="stock.cigares"><CigaresListPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/cigares/nouveau"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "gerante", "admin"]}>
            <FeatureRoute flag="stock.cigares"><CigaresFormPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/cigares/entrees"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "gerante", "caissiere", "admin"]}>
            <FeatureRoute flag="stock.cigares"><CigaresEntreesPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/cigares/ventes"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <FeatureRoute flag="stock.cigares"><CigaresVentesPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/cigares/:id"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "gerante", "admin"]}>
            <FeatureRoute flag="stock.cigares"><CigaresFormPage /></FeatureRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/patrimoine"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <PatrimoineListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/patrimoine/:id"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <PatrimoineDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/inventaire"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "gerante", "admin"]}>
            <InventairePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/inventaire/historique"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <InventaireHistoriquePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock/inventaire/historique/:id"
        element={
          <ProtectedRoute allowedRoles={["gestionnaire", "controleur", "gerante", "pdg", "admin"]}>
            <InventaireDetailPage />
          </ProtectedRoute>
        }
      />
    </>
  );
}
